import React from 'react';
import { creations } from '../data/creations';
export function CreationsGallery() {
  return <section aria-labelledby="creations-title" className="bg-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-55" data-mp="lbu4bgr2aqp4">
      <div className="max-w-6xl mx-auto" data-id="element-56" data-mp="gczevvyla3w1">
        <div className="max-w-2xl mx-auto text-center" data-id="element-57" data-mp="gbo6tjy429z4">
          <p className="text-xs font-semibold tracking-[0.12em] text-berry-deep" data-id="element-58" data-mp="cc71qrmljeuh">
            IDEEËN OM TE MAKEN
          </p>
          <h2 id="creations-title" className="mt-3 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum text-balance" data-id="element-59" data-mp="7dm8xd9obxg2">
            Stel je voor wat je kunt maken{' '}
            <span className="italic font-medium text-berry-deep" data-id="element-60" data-mp="3tt729piscj9j">met punnikkoord</span>.
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-61" data-mp="3ou3wu3yw8b11">
            Namen, beginletters, bloemen en kleine details: laat je inspireren door vormen en kleuren en geef er je eigen draai aan.
          </p>
        </div>

        <ul className="mt-10 sm:mt-14 grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-x-6 sm:gap-y-8 lg:grid-cols-3" data-id="element-62" data-mp="3fuh406k8cdjl">
          {creations.map(c => <li key={c.id} data-id="element-63" data-mp="1yc966bbvk4md">
              <figure data-id="element-64" data-mp="1ydkgktztsamg">
                <div className="aspect-[4/5] overflow-hidden rounded-[18px] bg-blush shadow-soft" data-id="element-65" data-mp="1ydtxls2w77g0">
                  <img src={c.src} alt={c.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-66" data-mp="1kmyyh7i744pm" />
                </div>
                <figcaption className="mt-3 text-center font-serif italic text-base sm:text-lg text-plum text-balance" data-id="element-67" data-mp="2ccjwnd99vh70">
                  {c.motif}
                </figcaption>
              </figure>
            </li>)}
        </ul>

        
      </div>
    </section>;
}